export default __webpack_public_path__ + "static/media/bar-chart.8c2ab70f.svg";